<template>
  <section id="con" class="parchment py-5">
    <div class="section">
      <!--      <div class="archive-warning mb-5">-->
      <!--        <p></p>-->
      <!--        <h3>Archiv!</h3>-->
      <!--        <p>-->
      <!--          Du befindest dich aktuell in unserem Archiv.-->
      <!--          Die Informationen hier beziehen sich auf eine alte Con und die <b>Anmeldung ist nicht mehr geöffnet!</b>-->
      <!--        </p>-->
      <!--      </div>-->
      <h1 class="mb-1">Die Blutinseln</h1>
      <h3 class="mt-1">Nacht des Amethyst</h3>
      <p></p>
      <h3>IT-Beschreibung</h3>
      <p>
        <i>
          Auf der belagerten Blutinsel zog eine düstere Macht ein, die die Winde der Magie in ihren Bann zog.
          Die einst stolze Burg erbebte vor finsteren Schatten, während die Insel dem Einfluss des Bösen erlag.
          Verzweiflung legte sich über das Land.
          Doch noch leuchtet ein Funken Hoffnung auf - bereit die Dunkelheit zu
          bezwingen.
        </i>
      </p>
      <p>
        Seid ihr dieser Funken und könnt der Dunkelheit die in die Burg gezogen ist Einhalt gebieten?
        Die Winde der Magie sind zurück und es bedarf keine weiteren Worte!
        Kommt zur Blutinsel und stellt euch dem Bösen.

      </p>

      <div class="flex-img-container">
        <a :href="img[0]" v-for="img in conImages[0]">
          <img :src="img[1]" />
        </a>
      </div>

      <p></p>
      <h3>OT-Beschreibung</h3>
      <p>
        Die Kampagne geht in die zweite Phase:
        Nach der Belagerung im Sommer heißt es nun auf zur Abenteuer-Con.
        Wir bieten euch eine Con im Warhammer-Universum, die voller Magie, Wunder und Abenteuer steckt!
      </p>
      <p>
        Gleichzeitig werden wir alles dafür tun, ein ausgewogenes SC/NSC-Verhältnis zu schaffen.
        Dafür belohnen wir SC, die selbst NSC mitbringen.
        Wie das ganze abläuft, erfahrt ihr weiter unten.
      </p>
      <p>
        <b>Was wird auf euch zukommen?</b>
      </p>
      <p>
        Eine Fantasy-Horror-Con:
        Ihr seid nirgends sicher!
        Wir möchten für euch gerne eine maximale Bedrohungslage schaffen, in der
        ihr nicht von Anfang an die großen unbesiegbaren Helden seid, sondern
        stattdessen erbitterte Gefechte und Rituale führen müsst.
      </p>
      <p>
        Seid ihr bereit mit uns an eure Grenzen zu gehen?
        Wir freuen uns sehr darauf!
      </p>
      <div style="
        background-color: rgba(255, 0, 0, 0.2);
        border-style: solid;
        padding: 0px 30px 30px;
        ">
        <h3>Keine Warhammer-Pflicht</h3>
        Wir spielen zwar im Warhammer-Universum, aber
        <b>Nicht-Warhammer-Charaktere sind dennoch willkommen!</b>
        Ihr müsst nicht unbedingt in der Alten Welt angesiedelt sein, um bei uns
        mitzuspielen.
        Bringt gerne auch eure anderen Mittelalter-Fantasy-Charaktere mit.
      </div>
      <p></p>
      <p>
        <!-- Facebook -->
        <a href="https://www.facebook.com/Freizeitritter-107039264349344/" class="mx-2 fa-2xl" target="_blank">
          <font-awesome-icon icon="fa-brands fa-facebook"></font-awesome-icon>
        </a>

        <!-- Instagram -->
        <a href="https://www.instagram.com/freizeitritter/" class="mx-2 fa-2xl" target="_blank">
          <font-awesome-icon icon="fa-brands fa-instagram"></font-awesome-icon>
        </a>
      </p>
      <p>Wir freuen uns auf eure Anmeldungen!</p>
      <p>Alle wichtigen Infos im Folgenden.</p>

      <div class="flex-img-container">
        <a :href="img[0]" v-for="img in conImages[1]">
          <img :src="img[1]" />
        </a>
      </div>

      <h3>Anmeldedaten</h3>
      <table class="table table-sm mt-3 mb-0">
        <thead>
          <tr>
            <th>Datum</th>
            <th>Ort</th>
            <th>Spielermenge</th>
            <th>Freie Plätze</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>06.10. - 08.10.2023</td>
            <td>67823<br />Burgruine<br />Obermoschel</td>
            <td>
              100 SC<br />
              60 NSC
            </td>
            <td>
              Es sind noch alle<br />
              Rollen verfügbar!
            </td>
          </tr>
        </tbody>
      </table>

      <h3>Anmeldeverfahren</h3>
      <p>
        Neben dem normalen Auswählen der Tickets (SC, NSC) kommt ein weiterer Punkt
        in unserem Anmeldeprozess auf euch zu:
        Nachdem ihr euch bei uns angemeldet habt durchlauft ihr wie
        gehabt einen Bewerbungsprozess.
        Was hier allerdings neu sein wird, ist, dass wir ein Gespräch mit euch führen um
        einfach mal abzustecken, was ihr euch von unserer Con wünscht und was wir so erwarten.
      </p>
      <p>
        <b>Wie wird dies ablaufen?</b>
      </p>
      <p>
        Gerne bei uns auf dem
        <a href="https://discord.gg/fqrEPQABVT" target="_blank">Discord Server</a>.
        Falls das nicht klappt, können wir auch telefonisch reden.
      </p>
      <p>
        Wenn das gelaufen ist, dann kommt ihr auf eine Warteliste:
        Sobald wir genug NSCs haben und ihr oben auf der Warteliste steht,
        bekommt ihr eine E-Mail von uns mit weiteren Daten.
        Ab dann habt ihr 7 Tage Zeit euch final anzumelden, indem ihr den Con-Beitrag überweist.
        Sollte diese Frist verstreichen, dann rutscht ihr automatisch in der
        Liste nach unten, damit wir anderen SC die Chance geben können, sich anzumelden.
      </p>
      <p>
        <b>Kann ich mich vormogeln?</b>
      </p>
      <p>
        Jawoll!
        Wir streben ein Verhältnis von 1 NSC zu 2 SC an.
        Wenn ihr selbst NSC zu unserer Con mitbringt und diese fest
        angemeldet sind, rutscht ihr direkt auf Platz 1 der Warteliste
        oder könnt euch sogar direkt anmelden, falls das Verhältnis
        zwischen NSC und SC weiterhin stimmt.
      </p>

      <h3>Magie? Magie!</h3>
      <p>
        Anders als auf unserer Belagerungs-Conreihe "Blutgetränkte Erde", gibt es auf
        unserer Abenteuer-Conreihe Magie und allerlei schöne Darstellungen davon
        werden sehr gerne gesehen.
      </p>

      <h3>NSC, GSC und Festrollen</h3>
      <p>
        Jeder NSC oder GSC der sich bei uns anmeldet, bekommt bei unserer
        PVP-Con "Blutgetränkte Erde" einen 10%-Rabatt auf das nächste Ticket,
        das er erwirbt.
      </p>
      <p>
        Wir bieten unseren NSC und GSC die ganze Con über kostenlose Verpflegung
        sowie nicht-alkoholische Getränke an.
      </p>
      <p>
        Die Unterbringung der NSC erfolgt in eigenen Zelten.
        Diese können auch OT sein.
        Ab fünf NSC bieten wir einen Gruppenrabatt von 10% an.
      </p>

      <h3>Regelwerk & FAQ</h3>
      <p>
        Da im Laufe der Zeit einige Fragen rund um den Ablauf und das Verhalten
        auf der Con aufgekommen sind, haben wir die wichtigsten Antworten in
        einem Dokument zusammengefasst. Dieses Dokument werden wir stetig
        erweitern. Auf der ersten Seite seht ihr jeweils die aktuelle Version.
        Teilnehmer werden aber natürlich alle wichtigen Informationen zusätzlich
        per Mail erhalten.
      </p>

      <a href="static/Freizeitritter-Regelwerk.pdf" target="_blank">
        <button class="btn btn-default">Zum Regelwerk</button>
      </a>

      <!-- TODO: auto-highlight currently active row (table-active) -->
      <table class="table table-sm my-4">
        <thead>
          <tr>
            <th>Anmeldezeitpunkt</th>
            <th>SC</th>
            <th>NSC</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Juli 2023</td>
            <td>70 EUR</td>
            <td>30 EUR</td>
          </tr>
          <tr>
            <td>August 2023</td>
            <td>80 EUR</td>
            <td>35 EUR</td>
          </tr>
          <tr>
            <td>September 2023</td>
            <td>90 EUR</td>
            <td>40 EUR</td>
          </tr>
          <tr>
            <td>Oktober und Conzahler nur nach Absprache</td>
            <td>100 EUR</td>
            <td>40 EUR</td>
          </tr>
        </tbody>
      </table>

      <form class="container">
        <div class="row">
          <input type="text" class="col-12" placeholder="Gruppenname" v-model="groupName" />
          <input type="number" class="col-12" placeholder="Spieler" v-model="amount" />
          <input type="button" value="Jetzt anmelden" @click="submitMail" class="btn btn-default btn-lg col-12" />
        </div>
      </form>

      <!-- Fallback-info for registration -->
      Der Anmelden-Knopf funktioniert nicht?
      <a href="javascript:void(0);" @click="fallbackShown = true">
        Dann klicke hier!
      </a>

      <p v-if="fallbackShown">
        Zum <b>Anmelden</b> sende bitte folgende E-Mail an
        <a :href="'mailto:' + generateMail().address">{{
          generateMail().address
        }}</a>. Wir kommen dann mit dem Rest auf euch zu.<br />
        <br />
        <b>Betreff:</b><br />
        {{ generateMail().subject }}<br />
        <br />
        <b>Inhalt:</b><br />
        {{ generateMail().body }}
      </p>

      <p></p>

      <div class="flex-img-container">
        <a :href="img[0]" v-for="img in conImages[2]">
          <img :src="img[1]" />
        </a>
      </div>

      <p></p>

      <div class="flex-img-container">
        <a :href="img[0]" v-for="img in conImages[3]">
          <img :src="img[1]" />
        </a>
      </div>

      <h3>Weitere Cons und Archiv</h3>
      <p>
        <a href="https://freizeitritter.de/" target="_blank">Hier</a>
        gehts zur Freizeitritter-Webseite, auf der ihr unsere anderen Cons und
        unser Archiv findet.
      </p>

      <p class="mt-5">
        Siehe auch:
        <a target="_blank" href="https://www.larpkalender.de/termine/index.html?aktion=suche&con_id=10630">Eintrag auf
          Thilo Wagners Larp-Kalendar</a>
      </p>
    </div>
    <div class="modal fade" id="registrationFallbackModal" tabindex="0">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Anmeldung</h5>
          </div>
          <div class="modal-body">
            <p>
              Sende folgende E-Mail an
              <b>{{ this.generateMail().address }}</b>
            </p>

            <b>Betreff</b>
            <pre>{{ this.generateMail().subject }}</pre>

            <b>Inhalt</b><br />

            <pre class="border border-primary rounded p-2"><code>{{ this.generateMail().body }}</code></pre>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "SectionCon",

  data() {
    return {
      groupName: "",
      amount: "",
      views: null,
      fallbackShown: false,
      conImages: [
        [
          [
            require("../img/con-img/BGE26.jpg"),
            new URL(
              "../img/con-img/BGE26.jpg?width=600",
              import.meta.url
            )
          ],
          // [
          //   require("../img/con-img/BGE71.jpg"),
          //   new URL(
          //     "../img/con-img/BGE71.jpg?width=600",
          //     import.meta.url
          //   )
          // ]
        ],
        [
          [
            require("../img/con-img/BGE123.jpg"),
            new URL(
              "../img/con-img/BGE123.jpg?width=600",
              import.meta.url
            )
          ],
          [
            require("../img/con-img/BGE145.jpg"),
            new URL(
              "../img/con-img/BGE145.jpg?width=600",
              import.meta.url
            )
          ],
        ],
        [
          // [
          //   require("../img/con-img/BGE8.jpg"),
          //   new URL(
          //     "../img/con-img/BGE8.jpg?width=600",
          //     import.meta.url
          //   )
          // ],
          [
            require("../img/con-img/BGE19.jpg"),
            new URL(
              "../img/con-img/BGE19.jpg?width=600",
              import.meta.url
            )
          ]
        ],
        [
          [
            require("../img/con-img/BGE134.jpg"),
            new URL(
              "../img/con-img/BGE134.jpg?width=600",
              import.meta.url
            )
          ],
          [
            require("../img/con-img/BGE176.jpg"),
            new URL(
              "../img/con-img/BGE176.jpg?width=600",
              import.meta.url
            )
          ],
        ]
      ]
    };
  },

  methods: {
    generateMail() {
      const address = "info@freizeitritter.de";
      const subject = "Anmeldung Die Blutinseln 2023 - Nacht des Amethyst";
      const body =
        `Gruppenname: ${this.groupName}\n` + `Anzahl: ${this.amount}\n`;

      return { address, subject, body };
    },

    submitMail() {
      const mail = this.generateMail();
      window.location =
        "mailto:" +
        mail.address +
        "?subject=" +
        mail.subject +
        "&body=" +
        encodeURIComponent(mail.body);
    }
  },
  mounted() {
    // properly scale images based on their aspect ratio
    // https://stackoverflow.com/questions/26434523/making-responsive-images-with-different-aspect-ratios-the-same-height#comment120909073_61002855
    document.querySelectorAll(".flex-img-container a").forEach((imgLink) => {
      const img = imgLink.firstElementChild;
      img.addEventListener("load", (event) => {
        const ratio = img.naturalWidth / img.naturalHeight;
        imgLink.style.flex = ratio;
      });
    });
  }
};
</script>
